import { useLatestLoan } from '../webapi';
import useBundle from 'hooks/useBundle';

export const useBusinessNoOverdue = () => {
  const { isBundleAccepted } = useBundle();
  const { latestLoan } = useLatestLoan();

  const total =
    (latestLoan?.totalOutstandingAmount || 0) +
    (latestLoan?.penaltyAmount || 0) +
    (latestLoan?.commissionAmount || 0) +
    ((isBundleAccepted && latestLoan?.openAgreementExtraFeesAmount) || 0);

  return { total };
};
